import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext, Link, useNavigate } from 'react-router-dom';

const References = () => {
  const { l } = useOutletContext();
  const navigate = useNavigate();
  const [references, setReferences] = useState([]);
  const [visibleCount, setVisibleCount] = useState(12); // 4 rows = 12 cards
  const [pageContent, setPageContent] = useState({
    ingressSwe: '',
    ingressEng: ''
  });

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        const response = await MakeRequest(null, 'content/references', 'get');
        if (response.data) {
          const filteredData = response.data
            .filter((ref) => 'Customer Testimonials' === ref.type)
            .sort((a, b) => (a.order || 9999) - (b.order || 9999));
          setReferences(filteredData);
        }
      } catch (error) {
        console.error('Error fetching references:', error);
      }
    };
    
    const fetchPageContent = async () => {
      try {
        const response = await MakeRequest(null, 'content/pageContent?page=references', 'get');
        if (response.data && response.data[0]) {
          setPageContent({
            ingressSwe: response.data[0].ingressSwe || '',
            ingressEng: response.data[0].ingressEng || ''
          });
        }
      } catch (error) {
        console.error('Error fetching page content:', error);
      }
    };
    
    fetchReferences();
    fetchPageContent();
  }, []);

  const handleReferenceClick = (reference) => {
    navigate(`/references/${reference._id}`, { state: { reference } });
  };

  const bgColors = ['#f8f9fa', '#e9ecef', '#dee2e6'];

  const truncate = (text) =>
    text?.length > 100 ? text.slice(0, 100) + '...' : text;

  const canShowMore = visibleCount < references.length;

  return (
    <Container className="my-lg-5 my-3">
      {/* Header row: title + link group inline on sm/md; split on lg+ */}
      <Row className="g-3 align-items-center mb-4">
        <Col xs="auto" className="d-flex align-items-center">
          <h1 className="fw-bold mb-0 me-3">{l('Kundutlåtanden', 'Customer testimonials')}</h1>
        </Col>

      </Row>

      {/* Intro paragraph: 12 cols on small/medium, 6 cols on lg+ */}
      <Row className="mb-2">
        <Col xs={12} lg={6}>
          <p className="text-muted lead mb-0 reference-intro">
            {pageContent.ingressSwe || pageContent.ingressEng ? (
              l(pageContent.ingressSwe, pageContent.ingressEng)
            ) : (
              l(
                'Våra produkter har prövats i mer än 50 år. Det har skett genom praktiska prover på objekt ute i naturlig miljö, genom labbtester och i kontrollerade fälttester. De har utförts av flertalet oberoende institutioner, och i jämförelse av våra produkter med likvärdiga produkter samt givetivis av oss själva genom vårt utvecklingsarbete med nya produkter. Här finner du utförda tester, kundutlåtanden, artiklar och rapporter om våra produkter.',
                'Our products have been tested for over 40 years. This has been done through practical tests on objects in their natural environment, through lab tests, and in controlled field tests. They have been carried out by several independent institutions, and in comparison of our products with equivalent products as well as of course by ourselves through our development work with new products. Here you will find completed tests, customer statements, articles, and reports about our products.'
              )
            )}
          </p>
        </Col>
      </Row>

      {/* Cards */}
      <Row className="g-3 g-md-4 mt-1">
        {references?.slice(0, visibleCount).map((reference, index) => (
          <Col
            key={reference._id?.$oid || reference._id || index}
            xs={12}
            sm={6}
            lg={4}
            className="d-flex"
          >
            <Card
              className="h-100 shadow-sm w-100 position-relative"
              style={{
                borderRadius: '15px',
                backgroundColor: bgColors[index % bgColors.length],
              }}
            >
              <Card.Body className="d-flex flex-column">
                <Card.Title className="mb-2">
                  {l(reference.titleSwe, reference.titleEng)}
                </Card.Title>

                <Card.Text
                  className="mb-3 flex-grow-1"
                  style={{ whiteSpace: 'pre-line' }}
                >
                  {l(truncate(reference.contentSwe), truncate(reference.contentEng))}
                </Card.Text>

                {/* Anchor for proper stretched-link behavior */}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleReferenceClick(reference);
                  }}
                  className="stretched-link fw-bold"
                  style={{ color: 'var(--bs-primary)' }}
                  aria-label={l('Läs mer', 'Read more')}
                >
                  {l('Läs mer →', 'Read more →')}
                </a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {canShowMore && (
        <div className="text-center mt-3">
          <Button
            variant="primary"
            onClick={() => setVisibleCount((prev) => prev + 12)} // add 4 rows (12 cards)
          >
            {l('Visa mer', 'Show more')}
          </Button>
        </div>
      )}
    </Container>

  );
};

export default References;
